import { render, staticRenderFns } from "./SelectBookYear.vue?vue&type=template&id=138bfb2b"
import script from "./SelectBookYear.vue?vue&type=script&lang=ts"
export * from "./SelectBookYear.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('138bfb2b')) {
      api.createRecord('138bfb2b', component.options)
    } else {
      api.reload('138bfb2b', component.options)
    }
    module.hot.accept("./SelectBookYear.vue?vue&type=template&id=138bfb2b", function () {
      api.rerender('138bfb2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bookyear/SelectBookYear.vue"
export default component.exports